/* eslint-disable react/prop-types */
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FormField from "../FormField";
import SoftBox from "components/SoftBox";
import { v4 as uuidv4 } from "uuid";
import SoftButton from "components/SoftButton";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import SoftTypography from "components/SoftTypography";
import SoftDatePicker from "components/SoftDatePicker";
import { formatDate, to_vietnamese } from "utils";
import FormFieldCurrency from "../FormField/currency";

export default function Products({ formData }) {
  const { getData, setProducts, setTotalNoTax, setTotalVAT, setTotalPaymentTax, setAmountWords } =
    formData;
  const { id } = useParams();
  const currentPath = window.location.pathname;
  const containsEdit = currentPath.includes("edit");
  const containsCreate = currentPath.includes("create");
  const [data, setData] = useState([]);

  useEffect(() => {
    if (getData && getData?.products?.length > 0) {
      const values = getData?.products.map((value) => {
        return {
          id: uuidv4(),
          name: value.name,
          unit: value.unit,
          quantity: value.quantity,
          price: value.price,
          tax: value.tax,
        };
      });
      let totalNoTax = 0;
      let totalVAT = 0;
      let totalPaymentTax = 0;
      for (const item of values) {
        const noTax = Number(item.quantity || 0) * Number(item.price || 0);
        totalNoTax += noTax;
        const vat = Number(noTax || 0) * Number(+item.tax / 100 || 0);
        totalVAT += vat;
        totalPaymentTax += Number(noTax) + Number(vat);
      }
      setTotalNoTax(totalNoTax);
      setTotalVAT(totalVAT);
      setTotalPaymentTax(totalPaymentTax);
      setAmountWords(to_vietnamese(totalPaymentTax) + " Đồng");
      setData(values);
      handleSetValues(values);
    }
  }, [getData.products]);

  const handleAdd = () => {
    const newProduct = {
      id: uuidv4(),
      name: "",
      unit: "",
      quantity: 0,
      price: 0,
      tax: 0,
    };
    setData((prev) => [...prev, newProduct]);
  };

  const handleDelete = (id) => {
    const arrData = data.filter((value) => value.id !== id);
    setData((prev) => prev.filter((value) => value.id !== id));
    handleSetValues(arrData);
  };

  const handleChangeValue = async (id, event) => {
    const { name, value } = event.target;

    let arrData = [];
    for (const item of data) {
      if (item.id === id) {
        const values = {
          ...item,
          [name]: value,
        };
        arrData.push(values);
      } else {
        arrData.push(item);
      }
    }
    setData(arrData);
    handleSetValues(arrData);
  };

  const handleSetValues = async (data) => {
    let value = [];
    let totalNoTax = 0;
    let totalVAT = 0;
    let totalPaymentTax = 0;
    for (const item of data) {
      const noTax = Number(item.quantity || 0) * Number(item.price || 0);
      totalNoTax += noTax;
      const vat = Number(noTax || 0) * Number(+item.tax / 100 || 0);
      totalVAT += vat;
      totalPaymentTax += Number(noTax) + Number(vat);

      value.push({
        name: item.name,
        unit: item.unit,
        quantity: +item.quantity,
        price: +item.price,
        tax: +item.tax,
      });
    }
    setTotalNoTax(totalNoTax);
    setTotalVAT(totalVAT);
    setTotalPaymentTax(totalPaymentTax);
    setAmountWords(to_vietnamese(totalPaymentTax) + " Đồng");
    setProducts(value);
  };

  return (
    <SoftBox style={{ position: "relative" }}>
      <SoftBox mt={1.625}>
        {data &&
          data.length > 0 &&
          data.map((product, index) => (
            <SoftBox key={product.id} mb={2}>
              {(id && containsEdit) || (!id && containsCreate) ? (
                <SoftButton
                  color="error"
                  size="small"
                  sx={{ marginBottom: 2 }}
                  onClick={() => handleDelete(product.id)}
                >
                  Xóa
                </SoftButton>
              ) : (
                <></>
              )}
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} mt={0.3} mb={0} sx={{ lineHeight: 0 }}>
                  <FormField
                    type="text"
                    label="Tên sản phẩm"
                    name={"name"}
                    value={product.name}
                    onChange={(e) => handleChangeValue(product.id, e)}
                    disabled={id && !containsEdit}
                  />
                </Grid>
                <Grid item xs={12} md={6} mt={0.3} sx={{ lineHeight: 0 }}>
                  <FormField
                    type="text"
                    label="Đơn vị tính"
                    name={"unit"}
                    value={product.unit}
                    onChange={(e) => handleChangeValue(product.id, e)}
                    disabled={id && !containsEdit}
                  />
                </Grid>
                <Grid item xs={12} md={6} mt={0.3} style={{ paddingTop: "0px" }}>
                  <FormField
                    type="number"
                    label="Số lượng"
                    name={"quantity"}
                    value={product.quantity}
                    onChange={(e) => handleChangeValue(product.id, e)}
                    disabled={id && !containsEdit}
                  />
                </Grid>
                <Grid item xs={12} md={6} mt={0.3} style={{ paddingTop: "0px" }}>
                  <FormFieldCurrency
                    type="number"
                    label="Giá tiền"
                    name={"price"}
                    value={product.price}
                    onChange={(e) => handleChangeValue(product.id, e)}
                    disabled={id && !containsEdit}
                  />
                </Grid>
                <Grid item xs={12} md={6} mt={0.3} style={{ paddingTop: "0px" }}>
                  <FormField
                    type="number"
                    label="Thuế (%)"
                    name={"tax"}
                    value={product.tax}
                    onChange={(e) => handleChangeValue(product.id, e)}
                    disabled={id && !containsEdit}
                  />
                </Grid>
              </Grid>
            </SoftBox>
          ))}
        {(id && containsEdit) || (!id && containsCreate) ? (
          <SoftBox display="flex" justifyContent="center" my={2}>
            <SoftButton color="dark" onClick={handleAdd}>
              Thêm
            </SoftButton>
          </SoftBox>
        ) : (
          <></>
        )}
      </SoftBox>
    </SoftBox>
  );
}
